import { motion, useReducedMotion } from 'framer-motion'
import { DUR } from '../motion/motionTokens'

// Lightweight celebration burst: ≤16 absolutely-positioned spans animated
// on transform/opacity only (compositor work, no layout). Gold sparks plus
// a few padel-ball-yellow dots. Positions derive from the index so the
// burst is stable without Math.random.

const COUNT = 14

function particleStyle(i: number) {
  const isBall = i % 5 === 0
  const size = isBall ? 8 : 5
  return {
    position: 'absolute' as const,
    left: '50%',
    top: '50%',
    width: size,
    height: size,
    borderRadius: '50%',
    background: isBall ? 'var(--ball-yellow)' : 'var(--trophy-gold)',
    pointerEvents: 'none' as const,
  }
}

export function CelebrationParticles() {
  const reduced = useReducedMotion()
  if (reduced) return null

  return (
    <>
      {Array.from({ length: COUNT }, (_, i) => {
        const angle = (i / COUNT) * Math.PI * 2 + (i % 3) * 0.25
        const distance = 70 + (i % 4) * 26
        return (
          <motion.span
            key={i}
            style={particleStyle(i)}
            initial={{ x: 0, y: 0, opacity: 1, scale: 1 }}
            animate={{
              x: Math.cos(angle) * distance,
              y: Math.sin(angle) * distance,
              opacity: 0,
              scale: 0.4,
            }}
            transition={{ duration: DUR.celebration + (i % 3) * 0.15, ease: 'easeOut' }}
          />
        )
      })}
    </>
  )
}
